'use client'

import { useCallback, useSyncExternalStore } from 'react'

function getServerSnapshot() {
  return false
}

/** 브레이크포인트를 렌더 snapshot으로 읽어 첫 클릭과 effect 사이의 분기를 없앤다. */
export function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') return () => {}
      const media = window.matchMedia(query)
      media.addEventListener('change', onChange)
      return () => media.removeEventListener('change', onChange)
    },
    [query]
  )
  const getSnapshot = useCallback(
    () =>
      typeof window.matchMedia === 'function' &&
      window.matchMedia(query).matches,
    [query]
  )

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
